import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from './shared/can-deactivate-guard.service';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'persons',
        loadChildren: './views/persons/persons.module#PersonsModule'
      },        
      {
        path: 'persons/:id',
        loadChildren: './views/person/person.module#PersonModule'
      },
      {
        path: 'companies',
        loadChildren: './views/companies/companies.module#CompaniesModule'
      },
      {
        path: 'companies/:id',
        loadChildren: './views/company/company.module#CompanyModule'
      },
      {
        path: 'publications/:code',
        loadChildren: './views/publications/publications.module#PublicationsModule'
      },
      {
        path: 'publications/issue/persons/:id',
        loadChildren: './views/publications/issue/issue-persons/issue-persons.module#IssuePersonsModule'
      },
      {
        path: 'publications/issue/companies/:id',
        loadChildren: './views/publications/issue/issue-companies/issue-companies.module#IssueCompaniesModule'
      },
      {
        path: 'queries/:rpt',
        loadChildren: './views/queries/queries.module#QueriesModule'
      }, 
      {
        path: 'survey',
        loadChildren: './views/survey/survey.module#SurveyModule'
      },
      {
        path: 'admin',
        loadChildren: './views/admin/admin.module#AdminModule'
      },   
      {
        path: 'admin/:id',
        loadChildren: './views/admin/admin-detail/admin-detail.module#AdminDetailModule'
      }, 
      {
        path: 'issue',
        loadChildren: './views/admin/publication-issue/publication-issue.module#PublicationIssueModule'
      },
      {
        path: 'altcity',
        loadChildren: './views/admin/alternate-city/alternate-city.module#AlternateCityModule'
      },      
    ]
  }
  ,{
    path: 'signin',
    component: SimpleLayoutComponent,
    loadChildren: './login/login.module#LoginModule',
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [CanDeactivateGuard]
})
export class AppRoutingModule {}
